import React from 'react';
import Styles from './MainContainer.module.css';

function MainContainer(props) {
  return (
    <div className={`${Styles.mainCard} ${props.className ?? ''}`}>
      {props.children}
    </div>
  );
}

export default MainContainer;
